export enum TaskStatusEnum {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    FINISHED = 'finished',
}
